module.exports = __webpack_public_path__ + "static/media/anage-parceria@2x.0657551a.png";